var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:youtube-fill",
    clipPath: "url(#clip0_1_1108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 4.68646C15.4954 4.68646 16.5164 4.71208 17.506 4.75399L18.6749 4.80987L19.7937 4.87623L20.8415 4.94725L21.7985 5.02176C22.8372 5.1008 23.8147 5.54383 24.5588 6.27282C25.3029 7.00182 25.7659 7.97001 25.8663 9.00687L25.9128 9.50166L26.0001 10.5611C26.0816 11.6589 26.1422 12.8558 26.1422 14.0002C26.1422 15.1446 26.0816 16.3414 26.0001 17.4393L25.9128 18.4987L25.8663 18.9935C25.7659 20.0305 25.3027 20.9989 24.5584 21.7279C23.814 22.4569 22.8362 22.8998 21.7973 22.9786L20.8427 23.052L19.7949 23.1241L18.6749 23.1905L17.506 23.2464C16.5046 23.2898 15.5024 23.3123 14.5 23.3139C13.4977 23.3123 12.4954 23.2898 11.494 23.2464L10.3251 23.1905L9.20633 23.1241L8.15854 23.052L7.20155 22.9786C6.16286 22.8996 5.18536 22.4565 4.44125 21.7276C3.69713 20.9986 3.23413 20.0304 3.13378 18.9935L3.08721 18.4987L2.9999 17.4393C2.91122 16.295 2.86385 15.1479 2.85786 14.0002C2.85786 12.8558 2.9184 11.6589 2.9999 10.5611L3.08721 9.50166L3.13378 9.00687C3.23409 7.97019 3.69693 7.00215 4.44081 6.27318C5.18468 5.54421 6.1619 5.10106 7.20039 5.02176L8.15621 4.94725L9.204 4.87623L10.324 4.80987L11.4929 4.75399C12.4947 4.71059 13.4973 4.68808 14.5 4.68646ZM12.1716 11.177V16.8234C12.1716 17.3613 12.7537 17.6966 13.2194 17.4288L18.1091 14.6056C18.2155 14.5443 18.3039 14.4561 18.3653 14.3498C18.4268 14.2436 18.4591 14.123 18.4591 14.0002C18.4591 13.8774 18.4268 13.7568 18.3653 13.6505C18.3039 13.5443 18.2155 13.456 18.1091 13.3948L13.2194 10.5727C13.1132 10.5114 12.9927 10.4791 12.87 10.4792C12.7474 10.4792 12.6269 10.5115 12.5207 10.5728C12.4145 10.6342 12.3263 10.7225 12.265 10.8287C12.2037 10.935 12.1715 11.0555 12.1716 11.1781V11.177Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.9412,
    height: 27.9412,
    fill: "white",
    transform: "translate(0.529419 0.0294189)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.c3bc3d3bba5569ec3eb534d5a34c3a5c.svg";
export { ForwardRef as ReactComponent };